<template>
  <div class="expertsPastRecommendations">
    <MobileNav :page_title="nav_title"></MobileNav>

    <LivePriceTickerVue></LivePriceTickerVue>

    <div class="expertsPastRecommendationsContainer">
      <div class="desktopFilterSection">
        <FilterForDesktopView :filter_title="filter_title" :filter_list="filter_list" user_type="expert"></FilterForDesktopView>
      </div>

      <div v-if="isPremiumPlan" class="search-container" style="display: flex">
        <!-- Back Icon -->
        <div class="back-icon-container" @click="$router.push('/data-categorisation')">
          <i class="el-icon-back"></i>
        </div>
        <div class="search-stock-section">
          <search-stock class="search-stock-component right-margin-15"></search-stock>
          <div class="flex-center" v-if="isPremiumPlan && !isDesktop">
            <img class="mobile-filter cursor-pointer" src="../assets/images/filter.svg" alt="" @click="openFilterDialog()" />
            <div v-if="filterCount" class="filter-count">{{ filterCount }}</div>
          </div>
        </div>
      </div>

      <div class="recoListSection">
        <div v-if="!is_reco_list_loading && !other_expert_past_reco_list.length">
          <NoDataFound :noDataContent="'No Live Recommendations by Expert'"></NoDataFound>
        </div>

        <div class="stock-data-section">
          <RecommendationDetailsCard :recommendationsList="other_expert_past_reco_list" @getByExpertName="getRecoByExpertName" @getByStockName="getRecoByStockName" @openStockWidget="openStockWidget"></RecommendationDetailsCard>
        </div>

        <div v-if="!currentUrl.includes('almondz.stockants.com') && !currentUrl.includes('almondztrade.stockants.com')">
          <div class="show-more-tab" v-if="this.number_of_pages > this.page_no && !is_reco_list_loading" @click="loadMoreRecommendations()">Load more</div>
        </div>
        <div v-if="(currentUrl.includes('almondz.stockants.com') || currentUrl.includes('almondztrade.stockants.com')) && isPremiumPlan">
          <div class="show-more-tab" v-if="this.number_of_pages > this.page_no && !is_reco_list_loading" @click="loadMoreRecommendations()">Load more</div>
        </div>

        <div :class="{ 'infinite-loader-top-position': page_no == 1 }" v-if="is_reco_list_loading">
          <div class="text-center">
            <img src="../assets/images/company/loader.svg" style="height: 80px; width: 80px" />
            <p>Please wait, page is loading . . .</p>
          </div>
        </div>
      </div>
    </div>

    <!-- video dialog -->
    <div id="video-section">
      <el-dialog :visible.sync="videoDialog" :before-close="videoDialogClose" center>
        <iframe id="videoId" width="100%" height="600px" :src="activeVideo" title="YouTube video player" frameborder="0" allowscriptaccess="always" allow="accelerometer; autoplay:true; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </el-dialog>
    </div>

    <!-- filters for mobile view -->
    <!-- isDesktop return true if window size is 1197px other wise false -->

    <StockFilter v-if="!isDesktop" :filter_title="filter_title" :filter_list="filter_list" user_type="expert" class="nav-filter-icon"></StockFilter>

    <el-dialog custom-class="stock-widget-dialog" :visible.sync="stock_widget_visible" :before-close="handleClose">
      <div>
        <iframe :src="'https://stocks.tickertape.in/' + stock_code + '?broker=stockants'" width="100%" height="400px"></iframe>
      </div>
    </el-dialog>

    <div v-if="userProfile != null">
      <ProcessKycComponent :planDetails="planSubscriptionStatusDetails"></ProcessKycComponent>
    </div>

    <!-- :kyc_confirmation_popup="is_kyc_confirmation_popup_visible" -->
    <ExpertViewPopups></ExpertViewPopups>

    <!-- <Footer class="footer-section top-margin-10"></Footer> -->
  </div>
</template>

<script>
import LivePriceTickerVue from '../components/LivePriceTicker.vue';
import ProcessKycComponent from '@/components/NewKycFlow.vue';
import ExpertViewPopups from '@/components/ExpertViewPopups.vue';
import { serverAddr } from '../networkConfig';
import MobileNav from '@/components/MobileNav.vue';
import RecoActionButtons from '@/components/RecoActionButtons.vue';
import MobileFilterDialog from '@/components/MobileFilterDialog.vue';
import SearchStock from '@/components/SearchStock.vue';
import NoDataFound from '@/components/NoDataFound.vue';
import FilterForDesktopView from '@/components/FilterForDesktopView.vue';
import RecommendationDetailsCard from '@/components/RecommendationDetailsCard.vue';
import { HelperNetworkCallBack } from '../mixins/Helper';
import { screenSize } from '../mixins/ScreenSize.js';
import { filterCallBack } from '../mixins/filter';
import { EventBus } from '../eventBus';
import moment from 'moment';
import { updateProfileNetworkCallBack } from '../mixins/UpdateProfile.NetworkCallBack';
import TopPotentialsRecos from '@/components/TopPotentialsRecos.vue';

export default {
  name: 'expertsPastRecommendations',

  mixins: [HelperNetworkCallBack, filterCallBack, screenSize, updateProfileNetworkCallBack],

  components: {
    MobileNav,
    'search-stock': SearchStock,
    NoDataFound,
    RecoActionButtons,
    FilterForDesktopView,
    RecommendationDetailsCard,
    StockFilter: MobileFilterDialog,
    ProcessKycComponent,
    ExpertViewPopups,
    TopPotentialsRecos,
    LivePriceTickerVue,
  },

  data() {
    return {
      moment: moment,
      planSubscriptionStatusDetails: null,
      nav_title: 'Experts Recommendations',
      filter_title: 'Experts recommendations',
      filter_obj: {
        company_id_list: [],
        expert_id_list: [],
        profession_list: [],
        filters: [],
        cmp_range: '',
      },
      filter_list: [
        {
          title: 'Market Participants',
          experts: ['Financial Advisor', 'Analyst'],
        },
        {
          title: 'Recommendation type',
          filter: ['Buy', 'Sell'],
        },
        {
          title: 'Market cap',
          filter: ['Large Cap', 'Mid Cap', 'Small Cap'],
        },
        {
          title: 'Sectors',
        },
        {
          title: 'Recommendation status',
          filter: ['Live', 'Updated', 'Yet to live', 'Target achieved', 'Target not achieved', 'Stop loss triggered', 'Exit'],
        },
        {
          title: 'Target period',
        },
      ],
      is_reco_list_loading: false, //loader placeholder
      other_expert_past_reco_list: [],
      stock_list: '',
      selected_reco_id: [],
      sector: '',
      is_scroll_disabled: true,
      page_no: 1,
      number_of_pages: null,
      stock_code: '',
      stock_widget_visible: false,
      campaignId: null,
      notificationData: [],
      activeVideo: 'https://youtube-nocookie.com/embed/QkUAhPDy81I',
      videoDialog: false,
      userProfile: {},
      currentEnvironment: {},
      websiteUserType: localStorage.getItem('websiteUserType') ? JSON.parse(localStorage.getItem('websiteUserType')) : {},
      is_profile_save_loading: false,
      isApiLoading: false,
      filterCount: null,
      appliedFilters: [],
      currentUrl: localStorage.getItem('currentUrl') ? localStorage.getItem('currentUrl') : window.location.href,
      isRecoListLoading: false,
      topPotentialRecommendations: [],
    };
  },
  watch: {
    filter_obj: {
      handler(newValue) {
        // Reset the appliedFilters array
        this.appliedFilters = [];

        // Check if the filter object is empty
        const isEmpty = Object.values(newValue).every((value) => {
          if (Array.isArray(value)) {
            return value.length === 0; // Empty array
          } else if (typeof value === 'object' && value !== null) {
            return Object.keys(value).length === 0; // Empty object
          }
          return !value; // Falsy value
        });

        if (isEmpty) {
          this.appliedFilters = [];
          this.filterCount = 0;
          return; // Exit early since there’s nothing to process
        }

        for (const key in newValue) {
          const value = newValue[key];

          if (Array.isArray(value) && value.length > 0) {
            // Process array values
            value.forEach((item) => {
              this.toggleFilter(item); // Add or remove the filter
            });
          } else if (typeof value === 'string' && value.trim() !== '') {
            // Process string values
            this.toggleFilter(value);
          } else if (typeof value === 'object' && Object.keys(value).length > 0) {
            // Process object values (convert to string for consistency)
            this.toggleFilter(value.key);
          }
        }
      },
      deep: true, // Ensure nested changes in `filter_obj` are detected
      immediate: true, // Trigger on initialization
    },
  },

  created() {
    if (!localStorage.getItem('currentEnvironment')) {
      this.selectUserType();
    }
    this.userProfile = JSON.parse(localStorage.getItem('profile'));

    if (localStorage.getItem('currentEnvironment')) {
      this.currentEnvironment = JSON.parse(localStorage.getItem('currentEnvironment'));
      // if (!this.currentEnvironment.byPassLogin) {
      this.addWatchlistFilter();
      // }
    }

    // this.checkKYCStatus();
  },

  mounted() {
    // Call getUserProfile initially
    this.getUserProfile();

    this.is_reco_list_loading = true;

    //event emmited when stock is removed
    EventBus.$on('clearedSearchedStock', () => {
      this.page_no = 1;
      this.stock_list = '';
      this.selected_reco_id = [];
      this.other_expert_past_reco_list = [];

      this.scrollToTop(); //scroll to top of list
      this.getOtherExpertsPastRecoList(this.filter_obj);
    });

    EventBus.$on('clearedSelectedFilter', (filter_obj) => {
      this.stock_list = '';
      this.selected_reco_id = [];
      this.page_no = 1;
      this.other_expert_past_reco_list = [];
      this.scrollToTop();
      this.filter_obj = filter_obj;

      // if user id, stock id or sector in url's query params then on cleared filter pushed them on relative filterobj
      // to get data accordingly
      if (this.$route.query.stock_id) {
        this.stock_list = this.$route.query.stock_id;
      } else if (this.$route.query.reco_id) {
        this.selected_reco_id = this.$route.query.stock_id;
      } else if (this.$route.query.user_id) {
        //if response type is company then sent user id in company id list other wise in expert id list
        var expert_id = Number(this.$route.query.user_id);
        this.filter_obj.expert_id_list.push(expert_id);
      } else if (this.$route.query.sector) {
        this.sector = this.$route.query.sector;
      }

      this.removeQueryParam();
      this.getOtherExpertsPastRecoList(this.filter_obj);
    });

    EventBus.$on('emitSelectedFilters', (filter_obj) => {
      this.page_no = 1;
      this.other_expert_past_reco_list = [];
      this.scrollToTop();
      this.filter_obj = filter_obj;

      //if params in route then pushed stock id in stock_list
      if (this.$route.query.stock_id) {
        this.stock_list = this.$route.query.stock_id;
      } else if (this.$route.query.reco_id) {
        this.selected_reco_id = this.$route.query.stock_id;
      } else if (this.$route.query.user_id) {
        var expert_id = Number(this.$route.query.user_id);
        this.filter_obj.expert_id_list.push(expert_id);
      } else if (this.$route.query.sector) {
        this.sector = this.$route.query.sector;
      } else if (this.$route.query.filter) {
        this.filter_obj.filters.push(this.$route.query.filter);
      }

      this.getOtherExpertsPastRecoList(this.filter_obj);
      this.removeQueryParam();
    });

    //event emmited when stock is selected
    EventBus.$on('selectedStock', (stock) => {
      this.page_no = 1;
      this.stock_list = '';
      this.selected_reco_id = [];
      this.other_expert_past_reco_list = [];
      this.stock_list = stock.id;

      this.scrollToTop(); //scroll to top of list

      if (this.stock_list) {
        this.getOtherExpertsPastRecoList(this.filter_obj);
      }
    });

    EventBus.$on('emitWatchListFilters', (filter_obj) => {
      if (this.isApiLoading) return;
      this.page_no = 1;
      this.other_expert_past_reco_list = [];
      this.scrollToTop();

      if (filter_obj) {
        if (this.filter_obj.filters.includes('followed stocks')) {
          let index = this.filter_obj.filters.indexOf('followed stocks');
          this.filter_obj.filters.splice(index, 1);
        } else {
          this.filter_obj.filters.push('followed stocks');
        }
      }
      //   this.filter_obj.filters = ["followed stocks"];
      this.getOtherExpertsPastRecoList(this.filter_obj);
    });

    EventBus.$on('toggleButtonLoading', (isLoading) => {
      this.isApiLoading = isLoading;
    });

    // run this after each 3 mins to refresh contents
    if (this.websiteUserType && this.websiteUserType.userType == 'broker') {
      setInterval(() => {
        window.location.reload(true);
      }, 5 * 60 * 1000);
    }
  },

  beforeRouteEnter(to, from, next) {
    var userPlan = JSON.parse(localStorage.getItem('plan_details'));

    if (!userPlan || (userPlan && userPlan.plan == 'Lite')) {
      next('/expert-view-lite');
    } else {
      next();
    }
  },
  methods: {
    getRecommendations() {
      this.isRecoListLoading = true; // Start loading
      serverAddr
        .get('/recommendation/v1/top_potential_recos')
        .then((response) => {
          if (response.data.data.length) {
            this.topPotentialRecommendations = response.data.data;
          }
        })
        .catch((error) => {
          console.log('Error fetching recommendations:', error);
        })
        .finally(() => {
          this.isRecoListLoading = false; // Stop loading
        });
    },

    toggleFilter(filter) {
      const index = this.appliedFilters.indexOf(filter);

      if (index > -1) {
        this.appliedFilters.splice(index, 1);
      } else {
        this.appliedFilters.push(filter);
      }
      this.filterCount = this.appliedFilters.length;
    },

    openFilterDialog() {
      EventBus.$emit('openFilterDialog');
    },
    getUserProfile() {
      this.is_profile_save_loading = true;

      serverAddr
        .get('/auth/v1/profile')
        .then(this.getProfileCallBack)
        .catch(function (error) {
          console.log(error);
        });
    },

    removeQueryParam() {
      // Access the current query parameters
      let queryParams = { ...this.$route.query };
      // Remove a specific query parameter (e.g., 'example')
      delete queryParams.stock_id;
      delete queryParams.user_id;
      delete queryParams.user;
      delete queryParams.public;
      delete queryParams.filter;

      // Update the URL without the query parameter
      this.$router.push({ query: queryParams });
    },
    addWatchlistFilter() {
      if (this.websiteUserType && this.websiteUserType.userType == 'broker') {
        this.filter_list.push({
          title: 'Watchlist',
          filter: ['followed stocks', 'traded stocks'],
        });
      } else {
        this.filter_list.push({
          title: 'Watchlist',
          filter: ['followed stocks'],
        });
      }
    },
    videoDialogClose() {
      this.videoDialog = false;
      let video = document.getElementById('videoId');
      let url = video.getAttribute('src');
      video.setAttribute('src', '');
      video.setAttribute('src', url);
    },

    openTradeWidget(stock_code, reco_id) {
      if (KiteConnect) {
        KiteConnect.ready(async function () {
          // Initialize a new Kite instance.
          // You can initialize multiple instances if you need.
          let kite = await new KiteConnect('s8r229rs5vrd6yzn');

          kite.add({
            exchange: 'NSE',
            tradingsymbol: stock_code,
            quantity: 1,
            order_type: 'LIMIT',
            // "transaction_type": "SELL",
            // "price": 105
          });
          // Register an (optional) callback.
          kite.finished(function (status, request_token) {});

          let id = '#default-button' + reco_id;

          // Render the in-built button inside a given target
          kite.renderButton(id);

          // OR, link the basket to any existing element you want
          // kite.link("#custom-button");
        });
      }
    },

    openStockWidget(stock_code) {
      this.stock_code = stock_code;
      this.stock_widget_visible = true;
    },

    // close stock widget dialog
    handleClose() {
      this.stock_widget_visible = false;
    },
    getRecommendationById(id_list) {
      this.stock_list = ''; //cleared previously selected stocks
      this.selected_reco_id = []; //cleared previously selected reco
      this.selected_reco_id = id_list;
      this.page_no = 1;
      this.other_expert_past_reco_list = []; //cleared previous results

      this.scrollToTop(); //scroll to top of list
      this.getOtherExpertsPastRecoList(this.filter_obj);
    },

    getRecoByStockName(reco) {
      this.selected_reco_id = []; //cleared previously selected reco
      this.stock_list = ''; //cleared previously selected stocks

      this.stock_list = reco.stock.id;

      this.page_no = 1;
      this.other_expert_past_reco_list = []; //cleared previous results
      this.scrollToTop(); //scroll to top of list
      this.getOtherExpertsPastRecoList(this.filter_obj);
    },

    getRecoByExpertName(expert_id) {
      this.filter_obj.expert_id_list = []; //cleared previously selected experts
      this.filter_obj.company_id_list = []; //cleared previously selected company
      this.stock_list = ''; //cleared previously selected stocks
      this.selected_reco_id = []; //cleared previously selected reco

      this.filter_obj.expert_id_list.push(expert_id); //pushed experts profile id

      this.page_no = 1;
      this.other_expert_past_reco_list = []; //cleared previous results
      this.scrollToTop(); //scroll to top of list
      this.getOtherExpertsPastRecoList(this.filter_obj);
    },

    scrollToTop() {
      var elmnt = document.getElementsByClassName('recoListSection');
      scrollTo(elmnt, 0, 100);
    },

    loadMoreRecommendations() {
      this.page_no = this.page_no + 1;
      // this.number_of_pages = null;     //to disable load more tab
      this.getOtherExpertsPastRecoList(this.filter_obj);
    },

    //initially called api to get all experts who uploaded reco
    getOtherExpertsPastRecoList(filter_obj) {
      if ((!Object.keys(this.subscribedPlanDetails).length || this.subscribedPlanDetails.plan == 'Lite') && localStorage.getItem('access_to_expert_dashboard') && this.page_no > 1) {
        if (localStorage.getItem('access_to_expert_dashboard') != this.$route.query.user_id) {
          this.page_no = 1; //reset to page no 1
          this.$store.commit('commitSubscribPlanDialogVisibility', true);
          return;
        }
      } else if ((!Object.keys(this.subscribedPlanDetails).length || this.subscribedPlanDetails.plan == 'Lite') && this.page_no > 1) {
        this.page_no = 1; //reset to page no 1
        this.$store.commit('commitSubscribPlanDialogVisibility', true);
        return;
      }
      //     if ((!Object.keys(this.subscribedPlanDetails).length || this.subscribedPlanDetails.plan == 'Lite')) {
      //   this.$router.push('/expert-view-lite');
      //   return;
      // }
      this.is_reco_list_loading = true;
      this.isApiLoading = true;
      EventBus.$emit('toggleButtonLoading', true);

      serverAddr
        .post('/recommendation/v1/read_recommendation', {
          page_per_entries: this.subscribedPlanDetails && this.subscribedPlanDetails.plan == 'Premium' ? 5 : 2,
          expert_list: filter_obj.expert_id_list,
          company_id_list: filter_obj.company_id_list,
          profession_list: filter_obj.profession_list,
          filters: filter_obj.filters ? filter_obj.filters : [],
          target_period: filter_obj.target_period ? filter_obj.target_period : '',
          page_no: this.page_no,
          sector: filter_obj.sector ? filter_obj.sector : this.sector ? this.sector : '',
          stock_id: this.stock_list,
          reco_id_list: this.selected_reco_id,
          cmp_range: filter_obj.cmp_range ? filter_obj.cmp_range : '',
          mtf_stock: filter_obj.mtf_stock ? filter_obj.mtf_stock : '',
          target_potential: filter_obj.top_potential ? filter_obj.top_potential : '',
          category_stamp: filter_obj.category_stamp ? filter_obj.category_stamp : '',
        })
        .then((response) => {
          if (response.data.status) {
            this.is_reco_list_loading = false;
            this.isApiLoading = false;
            EventBus.$emit('toggleButtonLoading', false);

            // this.is_scroll_disabled = true;   //enable scroll for more stock
            this.number_of_pages = response.data.pagination.total_pages;

            response.data.data.forEach((element, index) => {
              // created new key toggle_more_info in response for toggle more info section
              this.$set(element, 'toggle_more_info', false);
              this.$set(element, 'expert_list', []);
              this.$set(element, 'closed_reco_list', []);
              this.$set(element, 'closed_reco_list_loading', false);
              this.$set(element, 'is_loading', false);
              this.$set(element, 'compared_experts_list', []);
              this.$set(element, 'selectedRiskTag', element.risk_tags);
              this.$set(element, 'selected_brokerage_list', element.brokerage_data.IntraDay[0].data);
              this.$set(element, 'brokerage_list_type', 'IntraDay');
              this.$set(element, 'reco_quantity', 1);
              this.$set(element, 'exp_tax', element.brokerage_data.IntraDay[0].data.total_tax_and_charges);
              this.$set(element, 'brokerage_loader', false);
              this.$set(element, 'logic_description', element.report.length ? element.report[0].description : '');

              if (element.created_at != null && element.stock.today != null) {
                // if recos are filtered by company id then added new key filtered by to display their company name
                if (element.user.company && element.user.company.id != '') {
                  if (this.filter_obj.company_id_list.indexOf(element.user.company.id) != -1) {
                    this.$set(element, 'filtered_by', 'company');
                  }
                }

                //calculate difference between today & created date
                //if target is achieved then send target achieved date
                //if target is not achieved and accuracy is out then send result_date_time
                let start_date = element.created_at;

                element.reco_status == 'STOP LOSS TRIGGERED' || element.reco_status == 'TARGET NOT ACHIEVED';

                let end_date = element.reco_status == 'TARGET ACHIEVED' ? element.target_achieved_date_time : element.reco_status == 'TARGET NOT ACHIEVED' ? element.target_not_achieved_date_time : element.reco_status == 'STOP LOSS TRIGGERED' ? element.stop_loss_triggered_date_time : element.stock.today;

                element.difference_in_days = this.getDifferenceBetweenTwoDays(start_date, end_date);

                this.openTradeWidget(element.stock.symbol, element.id);
              } else {
                element.difference_in_days = 0;
              }

              this.other_expert_past_reco_list.push(response.data.data[index]);
            });

            // this.scrollToTop();         //scroll to top of the list
          } else {
            this.is_reco_list_loading = false;
            this.isApiLoading = false;
            EventBus.$emit('toggleButtonLoading', false);
            // this.is_scroll_disabled = false;
            this.other_expert_past_reco_list = [];
          }
        })
        .catch((error) => {
          console.log(error);
          this.is_reco_list_loading = false;
          this.isApiLoading = false;
          EventBus.$emit('toggleButtonLoading', false);
        });
    },

    loadMoreStocks() {
      window.onscroll = () => {
        //checked is window scrolled to bottom
        if (window.innerHeight + window.scrollY >= document.body.scrollHeight && this.is_scroll_disabled && this.number_of_pages > this.page_no) {
          // you're at the bottom of the page

          if ((!Object.keys(this.subscribedPlanDetails).length || this.subscribedPlanDetails.plan == 'Lite') && localStorage.getItem('access_to_expert_dashboard')) {
            if (localStorage.getItem('access_to_expert_dashboard') != this.$route.query.user_id) {
              this.stock_rank_board_page_no = 1; //reset to page no 1
              this.$store.commit('commitSubscribPlanDialogVisibility', true);
              return;
            }
          } else if (!Object.keys(this.subscribedPlanDetails).length || this.subscribedPlanDetails.plan == 'Lite') {
            this.stock_rank_board_page_no = 1; //reset to page no 1
            this.$store.commit('commitSubscribPlanDialogVisibility', true);
            return;
          }

          this.page_no = this.page_no + 1;
          this.getOtherExpertsPastRecoList(this.filter_obj);
          this.is_scroll_disabled = false; //disabled scroll to avoid many time function call
        }
      };
    },
  },

  computed: {
    //returns subscribed plan details from local storage
    subscribedPlanDetails() {
      return JSON.parse(localStorage.getItem('plan_details'));
    },

    isPremiumPlan() {
      const planDetails = this.subscribedPlanDetails;
      if (this.userProfile && planDetails && planDetails.plan === 'Premium') {
        this.getRecommendations();
      }
      return this.userProfile && planDetails && planDetails.plan === 'Premium';
    },
  },

  beforeDestroy() {
    EventBus.$off();
    // window.removeEventListener('scroll', this.loadMoreStocks());
    // this.is_scroll_disabled = false;
  },
};
</script>

<style lang="scss" scoped>
@import '../css/variable.scss';
@import '../css/common.scss';

.expertsPastRecommendations {
  // min-height: 100vh;
  background-color: $page-background-color;
  padding: 105px 0 60px 0;
}

.expertsPastRecommendations .stock-data-section {
  padding: 0px 0px 0;
}

.expertsPastRecommendations .search-container,
.TopPotentialRecos {
  /* box-shadow: 10px 0 20px 0px lightgrey; */
  box-sizing: border-box;
  // position: fixed;
  width: calc(100% - 285px);
  margin-left: 285px;
  padding: 0px 10px 0px 10px;
  z-index: 2;
}

.back-icon-container {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 24px;
  padding-top: 12px;
}

.back-icon {
  color: #333;
}
.expertsPastRecommendations .search-stock-section {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  box-sizing: border-box;
  background-color: $page-background-color;
  padding: 10px 0px 0px 10px;
  width: 100%;

  .filter-count {
    position: relative;
    bottom: 13px;
    right: 6px;
    padding: 2px 6px;
    background-color: #2488ff;
    font-size: 12px;
    font-weight: 600;
    border-radius: 50%;
    color: #fff;
  }

  .selected-filters {
    // width: 250px;
    display: flex;
    align-items: center;

    margin-top: 10px;

    .tabs-outer {
      display: flex;
      // width: 200px;
      flex-wrap: wrap;
    }

    .tabs {
      font-size: 0.6rem;
      font-weight: 500;
      background-color: #dde1ed;
      color: #606060;
      border-radius: 50px;
      padding: 3px 10px;
      margin: 2px 5px;
    }
  }
}

.expertsPastRecommendations .recoListSection {
  box-sizing: border-box;
  width: calc(100% - 285px);
  margin-left: 285px;
  padding: 10px 10px;
  min-height: calc(100vh - 120px);
}

.expertsPastRecommendations .footer-section {
  width: calc(100% - 285px);
  margin-left: 285px;
}

.expertsPastRecommendations .more-info-section {
  text-align: center;
  margin: 10px 0;
}

.expertsPastRecommendations .btn-gradient {
  background-image: linear-gradient(to left, #dc6250, #eb5151);
  margin: 10px 0 30px;
  width: 220px;
  outline: none;
  border-radius: 25px;
  height: 40px;
  color: #fff;
  font-size: 14px;
  border: none;
  cursor: pointer;
}

.expertsPastRecommendations .btn-gradient:hover {
  transition: 0.4s ease;
  box-shadow: 0px 0px 10px -1px #dc6250;
}

//media queries
@media screen and (max-width: 1283px) {
  .expertsPastRecommendations {
    padding: 105px 0 70px 0;
  }

  .expertsPastRecommendations .recoListSection {
    width: 100%;
    margin-left: 0;
  }

  .expertsPastRecommendations .footer-section {
    width: 100%;
    margin-left: 0;
  }

  .expertsPastRecommendations .search-container,
  .TopPotentialRecos {
    width: 100%;
    margin-left: 0;
    padding: 0;
  }

  .expertsPastRecommendations .search-stock-section {
    // display: block;
    padding: 20px 10px 0px 5px;
  }

  .expertsPastRecommendations .stock-data-section {
    padding: 0px 0px 0;
  }

  .expertsPastRecommendations .action-btn-component {
    display: flex;
    justify-content: center;
    margin: 10px 0;
  }

  .expertsPastRecommendations .desktopFilterSection {
    display: none;
  }

  .expertsPastRecommendations .search-stock-section .selected-filters {
    width: 100%;
    margin-top: 15px;

    .tabs-outer {
      width: auto;
    }
  }
}

@media screen and (max-width: 850px) {
  .expertsPastRecommendations .stock-data-section {
    padding: 0px 0px 0;
  }
}

@media screen and (max-width: 600px) {
  .expertsPastRecommendations .recoListSection {
    padding: 10px 0px 0px 0px;
  }
}
</style>

<style lang="scss">
.expertsPastRecommendations {
  .custom-seach-input {
    width: 240px;
  }
}

@media screen and (max-width: 850px) {
  // .expertsPastRecommendations {.plan-notification-dialog .el-dialog {
  //   width: 94%;
  // }}
}
</style>
